/*
  SCK (Oct 18, 2026): Desktop predictive search - keep the dropdown on screen.
  1. Position: the panel's top edge sits at the bottom of the visible header. If the page
     scrolls while it is open (or a sticky header is enabled), it stays below whatever header
     is still visible, or 8px from the top of the window, instead of sliding up out of view.
  2. Height: sets --sck-ps-max-h from the panel's real top edge, so it never runs past the
     bottom of the window; anything taller scrolls inside the panel.
  Only inline top and one CSS variable are written; theme.js still owns all search behaviour
  (fetching, opening, closing, Escape, click-outside).
*/
(function () {
  if (window.__sckPredictiveSearchFit) return;
  window.__sckPredictiveSearchFit = true;

  var SELECTOR = '.header-layout predictive-search.rmv-txt #predictive-search';
  var STICKY_SELECTOR = '.site-header--stuck, #StickyHeaderWrap';
  var BOTTOM_GAP = 16;
  var TOP_GAP = 8;
  var MIN_HEIGHT = 240;
  var desktop = window.matchMedia('(min-width: 1168px)');
  var timer = null;

  // Bottom edge of any header that is fixed/stuck to the top of the window right now.
  function stuckHeaderBottom() {
    var bottom = 0;
    var els = document.querySelectorAll(STICKY_SELECTOR);
    for (var i = 0; i < els.length; i++) {
      var pos = window.getComputedStyle(els[i]).position;
      if (pos !== 'fixed' && pos !== 'sticky') continue;
      var r = els[i].getBoundingClientRect();
      if (r.height > 0 && r.bottom > bottom && r.top <= 1) bottom = r.bottom;
    }
    return bottom;
  }

  function reset(panel) {
    if (panel.hasAttribute('data-sck-top')) {
      panel.style.removeProperty('top');
      panel.removeAttribute('data-sck-top');
    }
    if (panel.hasAttribute('data-sck-max-h')) {
      panel.style.removeProperty('--sck-ps-max-h');
      panel.removeAttribute('data-sck-max-h');
    }
  }

  function fit() {
    timer = null;
    var panels = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < panels.length; i++) {
      var panel = panels[i];
      if (!desktop.matches || panel.offsetParent === null) {
        reset(panel);
        continue;
      }

      // Natural position first (theme CSS), then hold it below the visible header if needed.
      if (panel.hasAttribute('data-sck-top')) {
        panel.style.removeProperty('top');
        panel.removeAttribute('data-sck-top');
      }
      var naturalTop = panel.getBoundingClientRect().top;
      // Never above the bottom of the header that contains the search (theme CSS places the
      // panel 16px up inside it), nor under a stuck header, nor off the top of the window.
      var ownHeader = panel.closest('.site-header');
      var ownHeaderBottom = ownHeader ? ownHeader.getBoundingClientRect().bottom : 0;
      var minTop = Math.max(TOP_GAP, stuckHeaderBottom() + TOP_GAP, ownHeaderBottom);
      var top = naturalTop;
      if (naturalTop < minTop) {
        var cssTop = parseFloat(window.getComputedStyle(panel).top) || 0;
        var nextTop = cssTop + (minTop - naturalTop);
        panel.style.setProperty('top', nextTop + 'px');
        panel.setAttribute('data-sck-top', String(nextTop));
        top = minTop;
      }

      var maxH = Math.max(MIN_HEIGHT, Math.floor(window.innerHeight - top - BOTTOM_GAP)) + 'px';
      if (panel.getAttribute('data-sck-max-h') !== maxH) {
        panel.setAttribute('data-sck-max-h', maxH);
        panel.style.setProperty('--sck-ps-max-h', maxH);
      }
    }
  }

  // A short timer rather than requestAnimationFrame, so it also runs in background tabs.
  function schedule() {
    if (timer === null) timer = window.setTimeout(fit, 16);
  }

  function init() {
    var panels = document.querySelectorAll(SELECTOR);
    if (!panels.length) return;
    // theme.js swaps the panel's innerHTML when results arrive, then shows it.
    var observer = new MutationObserver(schedule);
    for (var i = 0; i < panels.length; i++) {
      observer.observe(panels[i], { childList: true });
    }
    window.addEventListener('resize', schedule, { passive: true });
    // On scroll, reposition immediately so the panel doesn't visibly lag behind the page.
    window.addEventListener('scroll', fit, { passive: true });
    if (desktop.addEventListener) desktop.addEventListener('change', schedule);
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
